import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAdvertisingPlan = createAsyncThunk(
  "textarea/GetAdvertisingPlan",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AP_AdvertisingPlan/GetAdvertisingPlan"
      );

      const data = response.data.result;
      //console.log(data);

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AP_AdvertisingPlan = createSlice({
  name: "AP_AdvertisingPlan",
  initialState: {
    GetAdvertisingPlan: "",
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAdvertisingPlan.pending, (state, action) => {
        state.loading = true;
        state.countryOfProjectImplementation = action.payload;
        state.error = null;
      })
      .addCase(GetAdvertisingPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.countryOfProjectImplementation = action.payload;
      })
      .addCase(GetAdvertisingPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default AP_AdvertisingPlan.reducer;
